import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-privacy-for-all',
  templateUrl: './privacy-for-all.component.html',
  styleUrls: ['./privacy-for-all.component.scss']
})
export class PrivacyForAllComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
